export default __webpack_public_path__ + "static/media/university.20be7abc.png";